import React from 'react';

const SkipLink = ({ href = '#main-content', children = 'Aller au contenu principal' }) => {
  return (
    <a
      href={href}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-white px-4 py-2 rounded-lg z-50 focus:outline-none focus:ring-2 focus:ring-primary/50"
    >
      {children}
    </a>
  );
};

export default SkipLink;
